const topics = [
  { label: '热播推荐', hot: true, count: '126部' },
  { label: '院线新片', hot: true, count: '48部' },
  { label: '高分经典', hot: false, count: '312部' },
  { label: '国产精品', hot: true, count: '89部' },
  { label: '韩剧热播', hot: true, count: '56部' },
  { label: '日剧精选', hot: false, count: '73部' },
  { label: '美剧在线', hot: false, count: '94部' },
  { label: '动漫新番', hot: true, count: '67部' },
  { label: '综艺娱乐', hot: false, count: '105部' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              热门话题
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              大家都在看的影视话题，发现更多精彩
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((t) => (
              <a
                key={t.label}
                href="#media"
                className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-300 ${
                  t.hot
                    ? 'bg-primary-100/70 border-primary-200 hover:bg-primary-200/70 text-primary-700'
                    : 'bg-background-100 border-background-200 hover:border-primary-200 text-foreground-600 hover:text-primary-600'
                }`}
              >
                {t.hot && <i className="ri-fire-line text-xs"></i>}
                <span className="text-sm font-medium whitespace-nowrap">#{t.label}</span>
                <span className="text-xs opacity-70">{t.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}